
import React, { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, IcoAdd, IcoArrowRigth, IcoArrowRigthC, IcoArrowRigthCNovo, IcoCalendar, IcoCog, IcoHelpCircle, IcoProjeto1, IcoProjeto2, IcoProjeto3, IcoProjeto4, List, LoadingContent, MaskCpf, MaskData, Popover, dateCustom, IcoPdcaLink, IcoCompetitorGap  } from '../../components'

import { PopoverCentralAjuda } from '../../components/popovercentralajuda/popovercentralajuda';

import './meusProjetos.scss'
import { ativarInativaprojeto, listarMeusProjetos, projetoComentariosVistos, putListMeuProjeto, searchMovie } from './redux/meusProjetosActions'
import { useEffect } from 'react'
import Criar from './criar/criar-old'
import { modalOpen, setProjeto, setProjetoMeusProjetos, setInfoProjeto } from '../../layout/redux/layoutActions'
import { iconeprojeto, iconesList, typeStatusCustom } from './redux/meusProjetos'
import { IF, history } from '../../helpers'
import ObterMais from './obterMais'

import ModalAlerta from '../../layout/modalAlerta';
import { Modal } from '../../components'
import { modalAlertaInfo, modalClose, modalAlertaClean, informeNaoMostrar } from '../../layout/redux/layoutActions'
import AdquirirAtivos from '../minhasAssinaturas/content/adquirirAtivos';
import Video from '../videos/video'
import Listar from '../dashboard/listar'


export default () => {
  const dispatch = useDispatch()
  const { sistema, usuario, load  } = useSelector(state => state.layoutState)
  const nls = require(`./nls/${sistema.idioma}.json`)
  const nlsPopup = require(`../../layout/nlsPopup/${sistema.idioma}.json`)

  //PARA CENTRAL DE AJUDA CONTEXTUAL
  const nomedir = `../../centralajuda/nlscontexto/${sistema.idioma}.json`;
  console.log("NOMEDIRETORIO", nomedir)
  const nlsContexto = require(`../centralAjuda/nlscontexto/${sistema.idioma}.json`)
  const idarray = [100];
  const idarray1 = [101];
  const idarray2 = [102];
  const idarray3 = [103];

  const { listMeusProjetos, paginate } = useSelector(state=> state.meusProjetosState)

  // Estado para o modal de confirmação
  //const [modalAberto, setModalAberto] = useState(false); // Define se o modal está aberto
  //const [projetoParaInativar, setProjetoParaInativar] = useState(null); // Define o projeto que será inativado

  //const titulomodal11 = nls.modalid.id11titulo
  //const textomodal11 = nls.modalid.id11texto
  //const cancelarmodal11 = nls.cancelar
  //const confirmarmodal11 = nls.confirmar
  const datarenovacao = sistema.dataAtualizacaoAssinatura

  const [carregandoTelaInicial, setCarregandoTelaInicial] = useState(true)

  
  const formatarDataRenovacao = (data, idioma) => {
    // Mapeia o idioma 'esp' para 'es-ES' para compatibilidade com Intl.DateTimeFormat
    if (!data) {
      //console.log("DATA NÃO É NO FORMATO VÁLIDO")
      return "";
    }
    //console.log("DATA é VÁLIDO1!!!")
    const locale = idioma === "esp" ? "es-ES" : idioma;
    //console.log("DATA é VÁLIDO2!!!")
    return new Intl.DateTimeFormat(locale, {
      year: 'numeric',
      month: '2-digit',
      day: '2-digit'
    }).format(new Date(data));
  };

    const datarenovacaoformatada = formatarDataRenovacao(datarenovacao, sistema.idioma);
    //const textomodal11Atualizado = textomodal11.replace("XXXXX", datarenovacaoformatada);
    //console.log("datarenovacao", datarenovacao)
    //console.log("sistema.idioma", sistema.idioma)
    //console.log("datarenovacaoformatada", datarenovacaoformatada)

  //OLDX
  //useEffect(()=> {
  //  dispatch(listarMeusProjetos('', nlsPopup))
  //}, [sistema.idioma]) 


/*
 useEffect(() => {
  const carregarProjetos = async () => {
    try {
      // Usar await na chamada principal
      const projetos = await dispatch(listarMeusProjetos('', nlsPopup));
      console.log('Projetos carregados:', projetos.length);
    } catch (error) {
      console.error('Falha:', error);
    }
  };
  
  carregarProjetos();
}, [sistema.idioma, dispatch]);

*/

useEffect(() => {
  const carregarProjetos = async () => {
    try {
      setCarregandoTelaInicial(true)
      const projetos = await dispatch(listarMeusProjetos('', nlsPopup))
      console.log('Projetos carregados:', projetos?.length || 0)
    } catch (error) {
      console.error('Falha:', error)
    } finally {
      setCarregandoTelaInicial(false)
    }
  }

  carregarProjetos()
}, [sistema.idioma, dispatch])


  const headerDefault = [
    {
      column: 'projetoCuston',
      text: nls.listarProjetos.tableProjetos,
      className: '',
    },
    {
      column: 'tipo',
      text: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {nls.listarProjetos.tableTipo}
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray1} />
        </div>
      ),
      sort: '',
      className: '',
    },
    {
      column: 'segmentoDoProjeto',
      //text: nls.listarProjetos.tableSegmento,
      text: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {nls.listarProjetos.tableSegmento}
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray2} />
        </div>
      ),
      sort: '',
      className: '',
    },
    {
      column: 'statusCuston',
      //text: nls.listarProjetos.tableStatus,
      text: (
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          {nls.listarProjetos.tableStatus}
          <PopoverCentralAjuda nlsContexto={nlsContexto} idarray={idarray3} />
        </div>
      ),
      sort: '',
      className: '',
    },
    //{
    //  column: 'licencaDataCuston',
    //  text: nls.listarProjetos.tableLicenca,
    //  sort: '',
    //  className: '',
    //},
    {
      column: 'actions',
      text: '',
      sort: '',
      className: 'actions onlysvg',
    }
  ]

  const situacaoProjeto = [
    {id: 'A', name: nls.situacaoA},
    {id: 'I', name: nls.situacaoI},
    {id: 'AI', name: nls.situacaoAI},
  ]

  const handlePaginate = e => {
    console.warn(e, 'handlePaginate');
  }

  const handlePerPage = e => {
    console.warn(e, 'handlePerPage');
  }

  const handleConfigurar = e => {
    //history.push(`/meusprojetos/${e.idProjeto}/configurar`)
    history.push(`/myprojects/${e.idProjeto}/configure`)
  }

  const handlePdca = e => {
    history.push(`/myprojects/${e.idProjeto}/pdca`)
  }

  const handleCompetitorGap = e => {
    history.push(`/myprojects/${e.idProjeto}/competitorgaps`)
  }


  const handleVizualizarOLD = e => {
    console.log('PARTE - Projeto clicado:', e.idProjeto); // Debug
    dispatch(projetoComentariosVistos(e.idProjeto, e.nlsPopup));
    //dispatch(setProjeto({...e, id: e.idProjeto}, `/meusprojetos/${e.idProjeto}/csat`))   
    const ee = {...e,id: e.idProjeto}   
    console.log("PARTE LOGO ANTES COM E", ee)
    //dispatch(setProjeto({...e, id: e.idProjeto}, `/myprojects/${e.idProjeto}/feedbacks`))
    dispatch(setProjetoMeusProjetos({...e, id: e.idProjeto}, `/myprojects/${e.idProjeto}/feedbacks`))
  }



  const handleVizualizar = e => {
    console.log('PARTE - Projeto clicado:', e.idProjeto)

    dispatch(projetoComentariosVistos(e.idProjeto, nlsPopup))

    const {
      projetoCuston,
      statusCuston,
      licencaDataCuston,
      actions,
      ...projetoLimpo
    } = e

    const projetoParaVisualizar = {
      ...projetoLimpo,
      id: e.idProjeto,
      nomeProjeto: e.nomeProjeto || e.descricao
    }

    console.log("PARTE LOGO ANTES COM PROJETO LIMPO", projetoParaVisualizar)

    dispatch(setInfoProjeto(projetoParaVisualizar))

    dispatch(
      setProjetoMeusProjetos(
        projetoParaVisualizar,
        `/myprojects/${e.idProjeto}/feedbacks`
      )
    )
  }






  
  const handleMudaStatus = e => {
    const usuarioMaster = usuario.perfil?.id === 1;
    
    if (e.permissaoAlterarStatusProjeto) {
      if (!e.statusBolean) {       
          //console.log("ENTROU 1"); //ATIVAR PROJETO INATIVADO
          dispatch(ativarInativaprojeto(e, nlsPopup, usuarioMaster))
          dispatch(modalAlertaClean()) //NÃO CONSEGUI SIMULAR AQUI                
      } else {
        //console.log("ENTROU 3"); //INATIVAR PROJETO
        //dispatch(modalAlertaClean())
        dispatch(ativarInativaprojeto(e, nlsPopup, usuarioMaster))
        dispatch(modalAlertaClean()) //COLOQUEI PARA FECHAR O POPUP E DEU CERTO, NÃO CONSEGUI SIMULAR NAS SITAÇÕES ACIMA...
        
      }
      
    }
  }

//VERSÃO ANTIGA USAVA O MODAL OBTER-MAIS QUE CONTROLAVA NO FRONT O NÚMERO DE PROJETOS. AGORA VALIDAÇÃO NO BACK...
const handleMudaStatusOLD = e => {
  if (e.permissaoAlterarStatusProjeto) {
    if (!e.statusBolean) {
      if (sistema?.creditoConta?.creditoProjetos) {
        //console.log("ENTROU 1"); //ATIVAR PROJETO INATIVADO
        dispatch(ativarInativaprojeto(e, nlsPopup))
        dispatch(modalAlertaClean()) //NÃO CONSEGUI SIMULAR AQUI
      } 
      else{
        //console.log("ENTROU 2"); //ESSE É NO CASO DE TENTAR ATIVAR E NÃO TER CRÉDITO: Your account has no credits to create new projects. Get new credits by clicking here
        dispatch(modalOpen('obter-mais'))
        dispatch(modalAlertaClean()) //NÃO CONSEGUI SIMULAR AQUI
      }
    } else {
      //console.log("ENTROU 3"); //INATIVAR PROJETO
      //dispatch(modalAlertaClean())
      dispatch(ativarInativaprojeto(e, nlsPopup))
      dispatch(modalAlertaClean()) //COLOQUEI PARA FECHAR O POPUP E DEU CERTO, NÃO CONSEGUI SIMULAR NAS SITAÇÕES ACIMA...
      
    }
    
  }
}

//const handleCancelar = e => {
//  dispatch(modalClose())
//}


  const handleCriar = e => {
    if (sistema?.creditoConta?.creditoProjetos) {
      //console.log("ENTROU EM CRIAR PROJETO");
      //dispatch(modalOpen('AlterarContaEmpresarial'))
      dispatch(modalOpen('criarMeuProjeto'))
    } else{
      //console.log("NÃO ENTROU EM CRIAR PROJETO POR CAUSA DE CRÉDITO");
      dispatch(modalOpen('obter-mais'))
    }
  }

  const handleUpgradeCredito = e => {
    if (usuario?.permissoes?.VerFazerUpgrade) {
      dispatch(modalClose())
      history.push('/upgradeconta')
    } else if (usuario?.permissoes?.VerMinhasAssinaturas) {
      dispatch(modalOpen('assinaturas-adquirir-ativos'))
    }
  }
  
  /*
  if (carregandoTelaInicial) {
    return (
      <div className='box-meus-projetos'>
        <div className='box-content'>
          <LoadingContent show={!load} title={nls.loading}>
            <div />
          </LoadingContent>
        </div>
      </div>
    )
  }
  */

  if (carregandoTelaInicial) {
  return (
        <div className='box-meus-projetos' data-cy='page-myprojects'>
      <div className='box-content'>
        <LoadingContent
          show={!load}
          title={nls.loading}
          height="calc(100vh - 150px)"
        >
          <div />
        </LoadingContent>
      </div>
    </div>
  )
}



console.log('nls.carregando', nls.carregando)


  return (
        <div className='box-meus-projetos' data-cy='page-myprojects'>
      <div className='box-content'>
        <div className='box-content-topinfo'>
          {/*<h3>{nls.titleList} <Popover>{nls.mensagem.titlePopover}</Popover></h3>*/}
          <h3 style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {nls.titleList}
                        <PopoverCentralAjuda
              cy='help'
              nlsContexto={nlsContexto}
              idarray={idarray}
            />
                        <Video
              videoName="video9"
              cy="tutorial"
            />
          </h3>
          
          <div>
            <IF se={usuario?.permissoes?.CriarNovoProjeto}>
                            <Button
                data-cy='myprojects-create'
                color='primary circle'
                onClick={()=> handleCriar()}
              ><IcoAdd /> {nls.criar}</Button>
            </IF>
          </div>
        </div>
        <LoadingContent
          show={false}
          
        >
                    <List
            cy='myprojects-result'
            rowCy='myprojects-row'
            rowCyId={(e) => e.idProjeto}
            header={headerDefault}
            data={listMeusProjetos}
            listCustom={e=> {
              const item = e
              const statusInfo = typeStatusCustom(e.status)

              //const statusAction = a =>{
              //  if (a.situacao !== 'AI') {
              //    handleMudaStatus({...a, statusBolean: statusInfo.status})
              //  }
              //}

              //AQUI PARECE ESTAR FUNCIONANDO NA CHAMADA DO POPUP
              const statusAction = (a) => {
                if (a.situacao !== 'AI') {
                  const idpopup = a.situacao === 'A' ? 11 : 10;
                  // Dispara a ação modalAlertaInfo com o objeto necessário
                  dispatch(modalAlertaInfo({
                    ...nlsPopup[idpopup],  // Inclui o conteúdo de nlsPopup[5]
                    show: true,  // Garante que o modal será exibido
                    btnAction: () => handleMudaStatus({ ...a, statusBolean: statusInfo.status }), 
                    textos: {
                      'DataRenovacaoAssinatura': datarenovacaoformatada
                    }
                  }));
                  //handleCancelar()
                }
              };


              item.projetoCuston = <div className='info-projeto'>
                <div >{iconeprojeto(e?.icone)}</div>
                <div>
                  <label>{e.descricao}</label>
                  <p>{e.descricaoLonga}</p>
                </div>
              </div>

              item.statusCuston = e.permissaoAlterarStatusProjeto
              ? (e.situacao === 'AI'
                  ? <span className={`${statusInfo?.class} status-non-clickable`}>{nls[`situacao${e.situacao}`]}</span> // Apenas texto
                  : <span 
                      className={`${statusInfo?.class} status-clickable`} 
                      style={{cursor: 'pointer'}} 
                      onClick={() => statusAction(e)}
                    >
                      {nls[`situacao${e.situacao}`]}
                    </span>) // Botão clicável para outras situações
              : <span className={`${statusInfo?.class} status-non-clickable`}>{nls[`situacao${e.situacao}`]}</span>; // Apenas texto não editável


              // e.status?nls.ativo:nls.inativo
              item.licencaDataCuston = <span><IcoCalendar /> {MaskData(e.dataCriacao, '', sistema.idioma)}</span>
              
              
              /* Removi a ordem dos ícones de actions: primeiro Visualizar e depois configurar para não
              perder a formatação das colunas: somente o ícone de configuração pode não aparecer
              item.actions = <div>
                <Button
                  type='link'
                  onClick={()=> handleConfigurar(e)}
                  disabled={!e.permissaoEditarProjeto || e.situacao === 'I'}
                ><IcoCog /></Button>
                <Button
                  type='link'
                  color='primary'
                  onClick={()=> handleVizualizar(e)}
                  disabled={e.situacao === 'I'}
                >                  
                  {e.temComentariosNaoVistos ? <IcoArrowRigthCNovo /> : <IcoArrowRigth />}
                </Button>
              </div>
              */

                const cogDisabled = !e.permissaoEditarProjeto || e.situacao === 'I'

                /*
                const podeMostrarPdca =
                  e.permissaoPdcaGerirProjeto === true ||
                  (e.permissaoPdcaVerProjeto === true && e.temEmpresaPdca === true)
                */

                const podeMostrarPdca =
                  e.situacao === 'A' &&
                  (
                    e.permissaoPdcaGerirProjeto === true ||
                    (e.permissaoPdcaVerProjeto === true && e.temEmpresaPdca === true)
                  )  

                const podeMostrarCompetitorGap =
                  e.situacao === 'A' &&
                  e.temEmpresaPdca === true

                /*
                item.actions = (
                  <div>
                    {podeMostrarPdca && (
                      <Button
                        type='link'
                        onClick={() => handlePdca(e)}
                        disabled={e.situacao === 'I'}
                      >
                        <IcoPdcaLink style={{ transform: 'scale(1.25)' }} />
                      </Button>
                    )}

                    <Button
                      type='link'
                      color='primary'
                      onClick={() => handleVizualizar(e)}
                      disabled={e.situacao === 'I'}
                    >
                      {e.temComentariosNaoVistos ? <IcoArrowRigthCNovo /> : <IcoArrowRigth />}
                    </Button>

                    {!cogDisabled && (
                      <Button
                        type='link'
                        onClick={() => handleConfigurar(e)}
                      >
                        <IcoCog />
                      </Button>
                    )}
                  </div>
                )
                */

                item.actions = (
                  <div>
                    {podeMostrarPdca && (
                                            <Button
                        data-cy='myprojects-action'
                        data-cy-key='pdca'
                        type='link'
                        onClick={() => handlePdca(e)}
                        disabled={e.situacao === 'I'}
                        title='PDCA'
                      >
                        <IcoPdcaLink style={{ transform: 'scale(1.25)' }} />
                      </Button>
                    )}

                    {podeMostrarCompetitorGap && (
                                            <Button
                        data-cy='myprojects-action'
                        data-cy-key='competitor-gaps'
                        type='link'
                        onClick={() => handleCompetitorGap(e)}
                        disabled={e.situacao === 'I'}
                        title='Planos de Concorrência'
                      >
                        <IcoCompetitorGap />
                      </Button>
                    )}

                                        <Button
                      data-cy='myprojects-action'
                      data-cy-key='analytics'
                      data-cy-effect='write'
                      type='link'
                      color='primary'
                      onClick={() => handleVizualizar(e)}
                      disabled={e.situacao === 'I'}
                    >
                      {e.temComentariosNaoVistos ? <IcoArrowRigthCNovo /> : <IcoArrowRigth />}
                    </Button>

                    {!cogDisabled && (
                                            <Button
                        data-cy='myprojects-action'
                        data-cy-key='settings'
                        type='link'
                        onClick={() => handleConfigurar(e)}
                      >
                        <IcoCog />
                      </Button>
                    )}
                  </div>
                )

              return item
            }}
            // paginate={paginate}
            // actionPaginate={(e)=> handlePaginate(e)}
            // handlePerPage={(e)=> handlePerPage(e)}
            // nls={nls.paginacao}
          />
        </LoadingContent>
      </div>

      

      <Criar />
      <ObterMais type='conteudoProjetos' 
        actions={
          <Button
            type='btn'
            color='primary'
            size='block'
            variant='outlined'
            onClick={()=> handleUpgradeCredito()}
            disabled={usuario.perfil?.id === 2 ? true : false}
            title={usuario.perfil?.id === 2 ? nls.obterMais.naoPodeAdquirir : nls.obterMais.podeAdquirir}
          >{nls.obterMais.textobotaoadquirir}</Button>
        }
      />
      <AdquirirAtivos/>
    </div>
  )
}


